import {List, Text, Trails} from '@logistics-frontend/blocks'
import clsx from 'clsx'
import React from 'react'
import {NavLink} from 'react-router-dom'

import {classes} from './NavListItem.classes'

type Props = {
  title: string
  url: string
  isSelected: boolean
}

const NavListItem: React.FC<Props> = ({isSelected, title, url}) => {
  return (
    <NavLink className={clsx(classes.linkItem, isSelected && classes.selected)} to={url}>
      <Text>
        <List.Description variant="body2">{title}</List.Description>
      </Text>
      <Trails.Nav />
    </NavLink>
  )
}

export default NavListItem
